var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuplicate1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "56.69px",
    height: "56.69px",
    viewBox: "0 0 56.69 56.69",
    enableBackground: "new 0 0 56.69 56.69",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.347,56.692c15.655,0,28.347-12.69,28.347-28.346C56.693,12.692,44.002,0,28.347,0S0,12.692,0,28.347 C0,44.002,12.691,56.692,28.347,56.692"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.291,19.614v23.448H16.3l0.002-23.448H34.291 M37.291,16.614H13.303L13.3,46.062h23.991V16.614 L37.291,16.614z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "43.392,10.615 19.403,10.615 19.403,14.614 21.403,14.614 21.403,12.615 41.392,12.615  41.392,38.063 39.291,38.063 39.291,40.063 43.392,40.063  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 25.295,
    y1: 25.669,
    x2: 25.297,
    y2: 37.007
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 19.627,
    y1: 31.338,
    x2: 30.965,
    y2: 31.338
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate1);
export default __webpack_public_path__ + "static/media/duplicate_1.4ff3adbc81c2ce8d86eb5cd7eeb63e1c.svg";
export { ForwardRef as ReactComponent };